import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import camelCase from 'lodash/camelCase';
import { useTheme } from 'styled-components';
import { BuildingTypesEnum } from 'dash-common';
import { Form, FormContext, RawNumberSelect, TagSelect } from 'dash-ui';

import { FormFields } from 'containers/alerts/AddAlertModal/constants/constants';

function PropertyOptionsSection() {
  const { t } = useTranslation(['forms', 'forms', 'pages']);
  const { formState, stateHandlers } = useContext(FormContext);
  const theme = useTheme();

  const handleUnits = (field: FormFields) => (value: number | null) => {
    stateHandlers[field](value);
  };

  return (
    <>
      <Form.Group mt={4}>
        <Form.Label md color={theme.colors.n90}>
          {t('pages:propertyPage.propertyType')}
        </Form.Label>
        <TagSelect
          mt={2}
          options={Object.values(BuildingTypesEnum).map((item) => ({
            label: t(`forms:labels.buildingTypes.${camelCase(item)}`),
            value: item,
          }))}
          value={formState.buildingTypes as BuildingTypesEnum[]}
          onChange={(value) => stateHandlers[FormFields.BuildingTypes](value)}
        />
      </Form.Group>
      <Form.Group mt={4}>
        <Form.Label md color={theme.colors.n90}>
          {t('pages:propertyPage.numberOfBedrooms')}
        </Form.Label>
        <RawNumberSelect
          onChange={handleUnits(FormFields.NumberOfBedrooms)}
          value={formState.numberOfBedrooms}
        />
      </Form.Group>
      <Form.Group mt={4}>
        <Form.Label md color={theme.colors.n90}>
          {t('pages:propertyPage.numberOfBathrooms')}
        </Form.Label>
        <RawNumberSelect
          onChange={handleUnits(FormFields.NumberOfBathrooms)}
          value={formState.numberOfBathrooms}
        />
      </Form.Group>
    </>
  );
}

export default PropertyOptionsSection;
